import React from 'react';
import { Form } from '@dashboard/components/Formik';

export default function WebhooksForm({ integration, onSubmit }) {
  return (
    <Form
      initialValues={{
        config: {
          url: integration?.config?.url || '',
        },
      }}
      onSubmit={onSubmit}
      fields={[
        {
          name: 'config.url',
          label: 'Webhook URL',
          type: 'url',
        },
      ]}
      submitButton={{
        label: 'Save',
      }}
    />
  );
}
